export default __webpack_public_path__ + "35c62136ef03c87cdc98ce10a2c6788b.jpg";